<div id=hlth-pkg-detail *ngIf="!isBookingSubService">
    <ng-container>
        <div class="header border-bottom spac-btw">
            <div class="flex">
                <div (click)="closeModal()" class="float-left closeicon pointer">
                    <img src="./assets/icons/arrow.svg">
                </div>
                <div class="font-primary-subtitle bold" *ngIf="isReqRecieved">
                    <span *ngIf="paymentStatus=='S' || paymentStatus =='REQ'">{{ 'title_pkg_req_received'
                        |translate:'LABELS'}}
                    </span>
                    <span *ngIf="paymentStatus=='F'|| paymentStatus=='P'"> {{
                        'title_confirm_pkg_req'|translate:'LABELS'}} </span>
                    <span *ngIf="paymentStatus=='R'">{{ 'title_confirm_pkg_req'|translate:'LABELS'}}</span>
                </div>
            </div>
            <div (click)="closeModal()" class="float-right closeicon pointer">
                <img src="./assets/icons/close_black.svg">
            </div>
        </div>
    </ng-container>

    <div class="modal-pkg-content">
        <div class="card-review-alert" *ngIf="isReqRecieved">
            <div class="success-container">
                <img src="assets/icons/health-package/check.svg">
                <span class="font-default-small bold" *ngIf="paymentStatus=='S' || paymentStatus =='REQ'">{{'cal_modal_success_msg'|translate:'LABELS'}}</span>
                <span *ngIf="paymentStatus=='F'|| paymentStatus=='P'"> {{ 'msg_failed' | translate}} </span>
                <span *ngIf="paymentStatus=='R'">{{'msg_retry' | translate}}</span>
            </div>
            <div class="info-container">
                <div class="font-default-small col-9">{{'appt_dtl_msg_download_app_now'|translate:'LABELS'}}</div>
                <div class="logo-container col-3">
                    <div class="logo">
                        <img class="type-image" src="assets/images/app-googleplay.png" alt="">
                    </div>
                    <div class="logo">
                        <img class="type-image" src="assets/images/apple_play.png" alt="">
                    </div>
                    <div class="logo" *ngIf="false">
                        <img class="type-image" src="assets/images/apple_play.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="new-card-review">
            <div class="col">
                <app-appt-dtl-card [apptInfo]="apptConfirmDetails" [type]="'CONFIRMPACKAGE'"></app-appt-dtl-card>
            </div>
        </div>
    </div>
</div>

<div id=hlth-pkg-detail *ngIf="isBookingSubService">
    <ng-container>
        <div class="header border-bottom spac-btw">
            <div class="flex">
                <div (click)="closeModal()" class="float-left closeicon pointer">
                    <img src="./assets/icons/arrow.svg">
                </div>
                <div class="font-primary-subtitle bold">
                    <span>{{ 'appt_details' | translate:'LABELS'}}</span>
                </div>
            </div>
            <div (click)="closeModal()" class="float-right closeicon pointer">
                <img src="./assets/icons/close_black.svg">
            </div>
        </div>
    </ng-container>

    <div class="modal-pkg-content">
        <div class="card-review-alert">
            <div class="success-container">
                <img src="assets/icons/health-package/check.svg">
                <span class="font-default-small bold">{{'cal_modal_success_msg'|translate:'LABELS'}}</span>
                <span class="font-default-small bold" *ngIf="paymentStatus=='S' || paymentStatus =='REQ'">{{'cal_modal_success_msg'|translate:'LABELS'}}</span>
                <span *ngIf="paymentStatus=='F'|| paymentStatus=='P'"> {{ 'msg_failed' | translate}} </span>
                <span *ngIf="paymentStatus=='R'">{{'msg_retry' | translate}}</span>
            </div>
            <div class="info-container">
                <div class="font-default-small col-9">{{'appt_dtl_msg_download_app_now'|translate:'LABELS'}}</div>
                <div class="logo-container col-3">
                    <div class="logo">
                        <img class="type-image" src="assets/images/app-googleplay.png" alt="">
                    </div>
                    <div class="logo">
                        <img class="type-image" src="assets/images/apple_play.png" alt="">
                    </div>
                    <div class="logo" *ngIf="false">
                        <img class="type-image" src="assets/images/apple_play.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="new-card-review">
            <div class="col">
                <app-appt-dtl-card [apptInfo]="pkgDetail" [flowType]="'SUBSERVICECONFIRM'" [type]="'SUBSERVICECONFIRM'"
            (editAction)="switchActions($event)" [groupedServices]="groupedServices" [selectedPackage]="healthPkg?.selectedPackage"></app-appt-dtl-card>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <div class="btn-container">
        <ng-container *ngIf="!this.healthPkg?.reschedule">
            <button class="primary-button-outline" (click)="viewAppt()">{{'hlthpkg_confirm_view_appt' | translate}}</button>
            <button class="primary-button primary-btn" (click)="goToPkgDetails()">{{'hlthpkg_confirm_go_to_pkg_details' | translate}}</button>
        </ng-container>
        <ng-container *ngIf="this.healthPkg?.reschedule">
            <button class="primary-button primary-btn"  (click)="closeModal()">{{'go_to_home' | translate}}</button>
        </ng-container>
    </div>
</div>